import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SystemConfig = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to Data Cleanup as it's the main system config function
    navigate('/admin/data-management', { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-muted-foreground">Redirecting to Data Cleanup...</div>
    </div>
  );
};

export default SystemConfig;
